<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Plot Rent Adjustment Approvals</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Adjustment Approvals</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Plot Rent</a></li>
                    <li class="breadcrumb-item active">Adjustment Approvals</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Summary Cards -->
          <div class="row mb-4">
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Total Pending</p>
                      <h4 class="mb-0">{{ summary.totalPending || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-warning">
                      <span class="avatar-title">
                        <i class="mdi mdi-clock-outline font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Level 1</p>
                      <h4 class="mb-0 text-success">{{ summary.level1Count || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success">
                      <span class="avatar-title">
                        <i class="mdi mdi-account-check font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Level 2</p>
                      <h4 class="mb-0 text-warning">{{ summary.level2Count || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-warning">
                      <span class="avatar-title">
                        <i class="mdi mdi-account-supervisor font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Level 3</p>
                      <h4 class="mb-0 text-danger">{{ summary.level3Count || 0 }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-danger">
                      <span class="avatar-title">
                        <i class="mdi mdi-account-tie font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Credits</p>
                      <h4 class="mb-0 text-success">KES {{ numberFormat(summary.totalCredits || 0) }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-success">
                      <span class="avatar-title">
                        <i class="mdi mdi-arrow-down-bold font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium mb-2">Debits</p>
                      <h4 class="mb-0 text-danger">KES {{ numberFormat(summary.totalDebits || 0) }}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm align-self-center rounded-circle bg-danger">
                      <span class="avatar-title">
                        <i class="mdi mdi-arrow-up-bold font-size-24"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                  <h4 class="card-title mb-0">Pending Adjustments Queue</h4>
                  <div>
                    <button @click="getAdjustments" class="btn btn-outline-info">
                      <i class="mdi mdi-refresh me-1"></i>Refresh
                    </button>
                  </div>
                </div>

                <!-- Filters -->
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-3">
                      <input v-model="keyword" type="text" class="form-control" placeholder="Search by reference, plot, owner...">
                    </div>
                    <div class="col-md-2">
                      <select v-model="selectedLevel" class="form-select">
                        <option value="">All Levels</option>
                        <option value="1">Level 1 - Officer</option>
                        <option value="2">Level 2 - Supervisor</option>
                        <option value="3">Level 3 - Manager</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <select v-model="selectedType" class="form-select">
                        <option value="">All Types</option>
                        <option value="Credit">Credit</option>
                        <option value="Debit">Debit</option>
                      </select>
                    </div>
                    <div class="col-md-3">
                      <select v-model="selectedZone" class="form-select">
                        <option value="">All Zones</option>
                        <option v-for="zone in zones" :key="zone.zone" :value="zone.zone">{{ zone.zone }}</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <button @click="getAdjustments" class="btn btn-primary w-100">
                        <i class="mdi mdi-filter me-1"></i>Filter
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover">
                      <thead class="table-dark">
                        <tr>
                          <th>Reference</th>
                          <th>Plot Details</th>
                          <th>Type</th>
                          <th>Category</th>
                          <th>Amount</th>
                          <th>Balance Change</th>
                          <th>Approval Level</th>
                          <th>Requested</th>
                          <th>Reason</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="adj in adjustments" :key="adj.id">
                          <td>
                            <strong class="text-primary">{{ adj.adjustmentRef }}</strong>
                          </td>
                          <td>
                            <div>
                              <strong>{{ adj.plotNumber }}</strong>
                              <div class="text-muted small">{{ adj.zone }}</div>
                              <div class="text-muted small">{{ adj.ownerNames }}</div>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="adj.adjustmentType === 'Credit' ? 'bg-success' : 'bg-danger'">
                              <i class="mdi me-1" :class="adj.adjustmentType === 'Credit' ? 'mdi-arrow-down-bold' : 'mdi-arrow-up-bold'"></i>
                              {{ adj.adjustmentType }}
                            </span>
                          </td>
                          <td>{{ adj.adjustmentCategory }}</td>
                          <td class="text-end">
                            <strong :class="adj.adjustmentType === 'Credit' ? 'text-success' : 'text-danger'">
                              {{ adj.adjustmentType === 'Credit' ? '-' : '+' }} KES {{ numberFormat(adj.amount) }}
                            </strong>
                          </td>
                          <td class="text-center">
                            <span class="text-danger">{{ numberFormat(adj.balanceBefore) }}</span>
                            <i class="mdi mdi-arrow-right mx-1"></i>
                            <span :class="adj.balanceAfter > 0 ? 'text-danger' : 'text-success'">{{ numberFormat(adj.balanceAfter) }}</span>
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                              <span class="badge me-2" :class="getLevelBadgeClass(adj.currentApprovalLevel)">
                                Level {{ adj.currentApprovalLevel }}
                              </span>
                              <span class="text-muted small">of {{ adj.requiredApprovalLevel }}</span>
                            </div>
                            <small class="text-muted">{{ adj.approvalLevelName || '' }}</small>
                          </td>
                          <td>
                            <div>{{ adj.requestedBy }}</div>
                            <small class="text-muted">{{ formatDate(adj.requestedDate) }}</small>
                          </td>
                          <td>
                            <span class="text-truncate d-inline-block" style="max-width: 150px;" :title="adj.reason">
                              {{ adj.reason }}
                            </span>
                          </td>
                          <td>
                            <div class="btn-group">
                              <button @click="viewDetails(adj)" class="btn btn-sm btn-outline-info" title="View Details">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <button 
                                  v-if="canApprove(adj.currentApprovalLevel)" 
                                  @click="openApproveModal(adj)" 
                                  class="btn btn-sm btn-success" 
                                  title="Approve">
                                <i class="mdi mdi-check"></i>
                              </button>
                              <button 
                                  v-if="canApprove(adj.currentApprovalLevel)" 
                                  @click="openRejectModal(adj)" 
                                  class="btn btn-sm btn-danger" 
                                  title="Reject">
                                <i class="mdi mdi-close"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="adjustments.length === 0 && !loading">
                          <td colspan="10" class="text-center py-5">
                            <i class="mdi mdi-check-circle text-success" style="font-size: 48px;"></i>
                            <h5 class="mt-3">No Pending Adjustments</h5>
                            <p class="text-muted">All adjustment requests have been processed</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Loading -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading adjustments...</p>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white">
                  <nav class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="me-2">Rows Per Page</span>
                      <select class="form-select form-select-sm w-auto" v-model="pageSize">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                    <ul class="pagination mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" @click="prevPage">Previous</a>
                      </li>
                      <li class="page-item active">
                        <span class="page-link">{{ currentPage }} / {{ totalPages }}</span>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                        <a class="page-link" @click="nextPage">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Approve Modal -->
  <div class="modal fade" id="approveModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title text-white">
            <i class="mdi mdi-check-circle me-2"></i>Approve Adjustment
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body" v-if="selectedAdjustment">
          <div class="alert alert-info">
            <strong>Reference:</strong> {{ selectedAdjustment.adjustmentRef }}<br>
            <strong>Plot:</strong> {{ selectedAdjustment.plotNumber }} ({{ selectedAdjustment.zone }})<br>
            <strong>Type:</strong> {{ selectedAdjustment.adjustmentType }}<br>
            <strong>Amount:</strong> KES {{ numberFormat(selectedAdjustment.amount) }}<br>
            <strong>Current Level:</strong> {{ selectedAdjustment.currentApprovalLevel }} of {{ selectedAdjustment.requiredApprovalLevel }}
          </div>

          <div class="mb-3">
            <label class="form-label">Approval Comments (Optional)</label>
            <textarea v-model="approvalComments" class="form-control" rows="3" placeholder="Enter any comments..."></textarea>
          </div>

          <div class="alert" :class="selectedAdjustment.currentApprovalLevel >= selectedAdjustment.requiredApprovalLevel ? 'alert-success' : 'alert-warning'">
            <i class="mdi me-2" :class="selectedAdjustment.currentApprovalLevel >= selectedAdjustment.requiredApprovalLevel ? 'mdi-check-circle' : 'mdi-arrow-right-circle'"></i>
            <template v-if="selectedAdjustment.currentApprovalLevel >= selectedAdjustment.requiredApprovalLevel">
              <strong>Final Approval:</strong> This will apply the adjustment to the plot balance.
            </template>
            <template v-else>
              <strong>Escalation:</strong> This will escalate to Level {{ selectedAdjustment.currentApprovalLevel + 1 }} for further approval.
            </template>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button @click="approveAdjustment" class="btn btn-success" :disabled="isProcessing">
            <span v-if="isProcessing">
              <span class="spinner-border spinner-border-sm me-2"></span>Processing...
            </span>
            <span v-else>
              <i class="mdi mdi-check me-1"></i>Approve
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Reject Modal -->
  <div class="modal fade" id="rejectModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title text-white">
            <i class="mdi mdi-close-circle me-2"></i>Reject Adjustment
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body" v-if="selectedAdjustment">
          <div class="alert alert-warning">
            <strong>Reference:</strong> {{ selectedAdjustment.adjustmentRef }}<br>
            <strong>Plot:</strong> {{ selectedAdjustment.plotNumber }} ({{ selectedAdjustment.zone }})<br>
            <strong>Amount:</strong> KES {{ numberFormat(selectedAdjustment.amount) }}
          </div>

          <div class="mb-3">
            <label class="form-label">Rejection Reason <span class="text-danger">*</span></label>
            <textarea v-model="rejectionReason" class="form-control" rows="3" placeholder="Provide reason for rejection..." required></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button @click="rejectAdjustment" class="btn btn-danger" :disabled="isProcessing || !rejectionReason">
            <span v-if="isProcessing">
              <span class="spinner-border spinner-border-sm me-2"></span>Processing...
            </span>
            <span v-else>
              <i class="mdi mdi-close me-1"></i>Reject
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Details Modal -->
  <div class="modal fade" id="detailsModal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-info text-white">
          <h5 class="modal-title text-white">
            <i class="mdi mdi-information me-2"></i>Adjustment Details
          </h5>
          <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body" v-if="adjustmentDetails">
          <div class="row">
            <div class="col-md-6">
              <h6 class="fw-bold text-primary">Adjustment Information</h6>
              <table class="table table-sm">
                <tr><td class="text-muted">Reference:</td><td><strong>{{ adjustmentDetails.adjustment.adjustmentRef }}</strong></td></tr>
                <tr><td class="text-muted">Type:</td><td><span class="badge" :class="adjustmentDetails.adjustment.adjustmentType === 'Credit' ? 'bg-success' : 'bg-danger'">{{ adjustmentDetails.adjustment.adjustmentType }}</span></td></tr>
                <tr><td class="text-muted">Category:</td><td>{{ adjustmentDetails.adjustment.adjustmentCategory }}</td></tr>
                <tr><td class="text-muted">Amount:</td><td><strong>KES {{ numberFormat(adjustmentDetails.adjustment.amount) }}</strong></td></tr>
                <tr><td class="text-muted">Balance Before:</td><td>KES {{ numberFormat(adjustmentDetails.adjustment.balanceBefore) }}</td></tr>
                <tr><td class="text-muted">Balance After:</td><td>KES {{ numberFormat(adjustmentDetails.adjustment.balanceAfter) }}</td></tr>
                <tr><td class="text-muted">Status:</td><td><span class="badge" :class="getStatusBadgeClass(adjustmentDetails.adjustment.status)">{{ adjustmentDetails.adjustment.status }}</span></td></tr>
              </table>
            </div>
            <div class="col-md-6">
              <h6 class="fw-bold text-primary">Plot Information</h6>
              <table class="table table-sm">
                <tr><td class="text-muted">Plot Number:</td><td>{{ adjustmentDetails.adjustment.plotNumber }}</td></tr>
                <tr><td class="text-muted">Zone:</td><td>{{ adjustmentDetails.adjustment.zone }}</td></tr>
                <tr><td class="text-muted">Owner:</td><td>{{ adjustmentDetails.adjustment.ownerNames }}</td></tr>
                <tr><td class="text-muted">Current Balance:</td><td><strong class="text-danger">KES {{ numberFormat(adjustmentDetails.plot?.currentBalance || 0) }}</strong></td></tr>
              </table>
            </div>
          </div>

          <hr>

          <h6 class="fw-bold text-primary">Reason / Justification</h6>
          <p class="bg-light p-3 rounded">{{ adjustmentDetails.adjustment.reason }}</p>

          <h6 class="fw-bold text-primary">Approval Trail</h6>
          <div class="table-responsive">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Level</th>
                  <th>Action</th>
                  <th>By</th>
                  <th>Date</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="approval in adjustmentDetails.approvals" :key="approval.id">
                  <td>Level {{ approval.approvalLevel }}</td>
                  <td>
                    <span class="badge" :class="approval.action === 'Approved' ? 'bg-success' : 'bg-danger'">{{ approval.action }}</span>
                  </td>
                  <td>{{ approval.approvedBy }}</td>
                  <td>{{ formatDate(approval.approvalDate) }}</td>
                  <td>{{ approval.comments || '-' }}</td>
                </tr>
                <tr v-if="!adjustmentDetails.approvals || adjustmentDetails.approvals.length === 0">
                  <td colspan="5" class="text-center text-muted">No approval actions yet</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { execute, plotRent, getRight } from "@/api";

export default {
  name: "PlotRentAdjustmentApprovals",
  components: { NavigationBar },
  data() {
    return {
      adjustments: [],
      zones: [],
      summary: {},
      
      // Filters
      keyword: '',
      selectedLevel: '',
      selectedType: '',
      selectedZone: '',
      
      // Pagination
      currentPage: 1,
      pageSize: 25,
      totalPages: 1,
      totalRecords: 0,
      
      // Modal data
      selectedAdjustment: null,
      adjustmentDetails: null,
      approvalComments: '',
      rejectionReason: '',
      
      // State
      loading: false,
      isProcessing: false,
      
      // User approval levels (should come from session/permissions)
      userApprovalLevels: []
    }
  },
  mounted() {
    this.getAdjustments();
    this.getZones();
    this.loadUserPermissions();
  },
  watch: {
    pageSize() {
      this.currentPage = 1;
      this.getAdjustments();
    }
  },
  methods: {
    getRight(type) {
      return getRight(type);
    },

    loadUserPermissions() {
      // Determine which approval levels the user can approve
      this.userApprovalLevels = [];
      if (getRight('PLOTRENT ADJUSTMENT APPROVAL')) this.userApprovalLevels.push(1);
      if (getRight('PLOTRENT ADJUSTMENT APPROVAL')) this.userApprovalLevels.push(2);
      if (getRight('PLOTRENT ADJUSTMENT APPROVAL')) this.userApprovalLevels.push(3);
    },

    canApprove(level) {
      return this.userApprovalLevels.includes(parseInt(level));
    },

    getAdjustments() {
      this.loading = true;
      this.adjustments = [];

      const data = new FormData();
      data.append("function", "getPendingAdjustments");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("keyword", this.keyword);
      data.append("approvalLevel", this.selectedLevel);
      data.append("adjustmentType", this.selectedType);
      data.append("zone", this.selectedZone);

      execute(data, plotRent)
        .then((res) => {
          this.loading = false;
          if (res.data.success) {
            this.adjustments = res.data.data.adjustments || [];
            this.summary = res.data.data.summary || {};
            this.totalRecords = res.data.data.count?.count || 0;
            this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
          }
        })
        .catch((e) => {
          this.loading = false;
          console.error(e);
        });
    },

    getZones() {
      const data = new FormData();
      data.append("function", "getZones");

      execute(data, plotRent)
        .then((res) => {
          if (res.data.success) {
            this.zones = res.data.data.zones || [];
          }
        })
        .catch((e) => console.error(e));
    },

    viewDetails(adjustment) {
      const data = new FormData();
      data.append("function", "getAdjustmentDetails");
      data.append("adjustmentID", adjustment.id);

      execute(data, plotRent)
        .then((res) => {
          if (res.data.success) {
            this.adjustmentDetails = res.data.data;
            const modal = new bootstrap.Modal(document.getElementById('detailsModal'));
            modal.show();
          }
        })
        .catch((e) => {
          alert("Error loading details: " + e.message);
        });
    },

    openApproveModal(adjustment) {
      this.selectedAdjustment = adjustment;
      this.approvalComments = '';
      const modal = new bootstrap.Modal(document.getElementById('approveModal'));
      modal.show();
    },

    openRejectModal(adjustment) {
      this.selectedAdjustment = adjustment;
      this.rejectionReason = '';
      const modal = new bootstrap.Modal(document.getElementById('rejectModal'));
      modal.show();
    },

    approveAdjustment() {
      if (!this.selectedAdjustment) return;

      this.isProcessing = true;

      const data = new FormData();
      data.append("function", "approveAdjustment");
      data.append("adjustmentID", this.selectedAdjustment.id);
      data.append("adjustmentRef", this.selectedAdjustment.adjustmentRef);
      data.append("comments", this.approvalComments);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("sessionRole", sessionStorage.getItem("sessionRole") || '');

      execute(data, plotRent)
        .then((res) => {
          this.isProcessing = false;
          
          if (res.data.success) {
            alert(res.data.message);
            this.closeModal('approveModal');
            this.getAdjustments();
          } else {
            alert("Failed: " + res.data.message);
          }
        })
        .catch((e) => {
          this.isProcessing = false;
          alert("Error: " + e.message);
        });
    },

    rejectAdjustment() {
      if (!this.selectedAdjustment || !this.rejectionReason) return;

      this.isProcessing = true;

      const data = new FormData();
      data.append("function", "rejectAdjustment");
      data.append("adjustmentID", this.selectedAdjustment.id);
      data.append("reason", this.rejectionReason);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("sessionRole", sessionStorage.getItem("sessionRole") || '');

      execute(data, plotRent)
        .then((res) => {
          this.isProcessing = false;
          
          if (res.data.success) {
            alert("Adjustment rejected successfully");
            this.closeModal('rejectModal');
            this.getAdjustments();
          } else {
            alert("Failed: " + res.data.message);
          }
        })
        .catch((e) => {
          this.isProcessing = false;
          alert("Error: " + e.message);
        });
    },

    closeModal(modalId) {
      const modal = bootstrap.Modal.getInstance(document.getElementById(modalId));
      if (modal) modal.hide();
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getAdjustments();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getAdjustments();
      }
    },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    getLevelBadgeClass(level) {
      switch (parseInt(level)) {
        case 1: return 'bg-success';
        case 2: return 'bg-warning text-dark';
        case 3: return 'bg-danger';
        default: return 'bg-secondary';
      }
    },

    getStatusBadgeClass(status) {
      switch (status) {
        case 'Approved': return 'bg-success';
        case 'Rejected': return 'bg-danger';
        case 'Cancelled': return 'bg-secondary';
        default: return 'bg-warning text-dark';
      }
    }
  }
}
</script>

<style scoped>
.mini-stats-wid .card-body {
  padding: 1rem;
}
.mini-stat-icon {
  width: 40px;
  height: 40px;
}
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: white;
}
</style>
